import api from "@/api/index";

/**
 * Service pour le calcul de ration
 */
export const calculRationService = {
  /**
   * Effectue le calcul de ration via le webservice
   * @param {Object} data - Données du calcul de ration
   * @returns {Promise} Promesse contenant le résultat du calcul
   */
  async calculateRation(data) {
    try {
      const response = await api.post("/rations/calculate", data);
      return response.data;
    } catch (error) {
      console.error("Erreur lors du calcul de ration:", error);
      throw error;
    }
  },

  /**
   * Sauvegarde le calcul de ration via le webservice
   * @param {Object} data - Données de sauvegarde de la ration
   * @returns {Promise} Promesse contenant le résultat de la sauvegarde
   */
  async saveRation(data) {
    try {
      const response = await api.post("/saved-rations", data);
      return response.data;
    } catch (error) {
      console.error("Erreur lors de la sauvegarde de ration:", error);
      throw error;
    }
  },

  /**
   * Met à jour une ration existante
   * @param {number} id - ID de la ration
   * @param {Object} data - Données à mettre à jour
   * @returns {Promise} Promesse contenant le résultat de la mise à jour
   */
  async updateRation(id, data) {
    try {
      const response = await api.put(`/saved-rations/${id}`, data);
      return response.data;
    } catch (error) {
      console.error("Erreur lors de la mise à jour de la ration:", error);
      throw error;
    }
  },

  /**
   * Récupère les rations groupées par propriétaires
   * @param {string} search - Terme de recherche pour filtrer les propriétaires
   * @returns {Promise} Promesse contenant la liste des propriétaires avec leurs rations
   */
  async getGroupedRationsByOwners(search = "") {
    try {
      const params = {};
      if (search && search.trim()) {
        params.search = search.trim();
      }

      const response = await api.get("/rations/grouped-by-owners", { params });
      return response.data;
    } catch (error) {
      console.error("Erreur lors de la récupération des rations groupées:", error);
      throw error;
    }
  },

  /**
   * Supprime une ration sauvegardée
   * @param {number} rationId - ID de la ration à supprimer
   * @returns {Promise} Promesse contenant le résultat de la suppression
   */
  async deleteRation(rationId) {
    try {
      const response = await api.delete(`/saved-rations/${rationId}`);
      return response.data;
    } catch (error) {
      console.error("Erreur lors de la suppression de la ration:", error);
      throw error;
    }
  },
};
